<template>
    <div
        class="activity-item d-flex align-center"
        style="gap:16px"
    >
        <div class="activity-item__icon">
            <v-icon
                :color="iconColor"
                size="18"
            >
                {{ icon }}
            </v-icon>
        </div>
        <div class="flex-grow-1" style="min-width:0">
            <h4 class="card-title-strong" style="font-size:0.875rem;margin:0 0 2px">
                <slot name="title">{{ title }}</slot>
            </h4>
            <p
                class="body-xs"
                style="margin:0"
            >
                <slot>{{ description }}</slot>
            </p>
        </div>
        <span
            v-if="time"
            class="text-faint"
            style="font-size:10px;flex-shrink:0"
        >
            {{ time }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ActivityItem',
    props: {
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        time: { type: String, default: '' },
        icon: { type: String, default: 'mdi-circle-medium' },
        iconColor: { type: String, default: 'primary' },
    },
}
</script>

<style scoped>
.activity-item__icon {
    width: 40px;
    height: 40px;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid var(--glass-panel-border);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
</style>
